import { styled } from 'styled-components'
import COLORS from '@web-ui-kit/colors'
import SPACES from '@web-ui-kit/spaces'
export const Wrapper = styled.section`
  background-color: var(--white);
  height: 100%;
  left: 0;
  position: fixed;
  right: 0;
  text-align: center;
  z-index: 99999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${SPACES.XL};
`
export const Container = styled.div`
  padding: ${SPACES.XL};
  background-color: ${COLORS.NEUTRAL_50};
  border-radius: 1.25rem;
  gap: ${SPACES.XL};
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1128px;
  width: 100%;
  margin: 0 auto;
`

export const ContentInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${SPACES.S};
`
